export const B2CPartnerId = '4'; // Wishi partner id
